// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.csv-parser[data-v-af3f1c80] {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 20px;\n}\n.file-upload-btn[data-v-af3f1c80] {\r\n    margin-bottom: 10px;\n}\n.error-message[data-v-af3f1c80] {\r\n    color: red;\r\n    margin-top: 10px;\n}\n.sensor-info[data-v-af3f1c80] {\r\n    margin-top: 10px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
